var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"at-message-qoute"},[_c('div',{staticClass:"at-message-qoute_content"},[_c('span',[_vm._v(_vm._s(_vm.messageProps.message))])]),_vm._t("message_actions")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }